import { FieldType } from "@brushfire/types";
var Regex = {
    guid: "([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})",
};
var Routes = {
    eventList: "/:clientKey/:urlKey?",
    map: "/:clientKey/:urlKey?/map",
    calendar: "/:clientKey/:urlKey?/calendar/:date?/:eventNumber?/:sharedCapacityId?",
    eventStart: "/:clientKey/:urlKey/:eventNumber",
    details: "/:clientKey/:urlKey/:eventNumber/details",
    emailDirections: "/:clientKey/:urlKey/:eventNumber/directions",
    resetGroup: "/:clientKey/:urlKey/:eventNumber/reset",
    register: "/:clientKey/:urlKey/:eventNumber/register",
    tickets: "/:clientKey/:urlKey/:eventNumber/tickets",
    autoreg: "/:clientKey/:urlKey/:eventNumber/auto",
    autogroup: "/:clientKey/:urlKey/:eventNumber/autogroup",
    section: "/:clientKey/:urlKey/:eventNumber/assigned/:section",
    questions: "/:clientKey/:urlKey/:eventNumber/questions/:attendeeId?",
    addons: "/:clientKey/:urlKey/:eventNumber/addons",
    cart: "/:clientKey/:urlKey/:eventNumber/cart",
    checkout: "/:clientKey/:urlKey/:eventNumber/checkout",
    results: "/:clientKey/:urlKey/:eventNumber/results/:hash",
    assignedReroute: "/:clientKey/:urlKey/:eventNumber/assigned",
    signature: "/:clientKey/:urlKey/:eventNumber/signatureresponse",
    profile: "/my/profile",
    //Post Attendee Routes
    lookup: "/my/:lookupId?",
    myAttendees: "/:clientKey/:urlKey/:eventNumber/my/attendees",
    myAttendeesPayment: "/:clientKey/:urlKey/:eventNumber/my/attendees/payment",
    myAttendeesShare: "/:clientKey/:urlKey/:eventNumber/my/attendees/share",
    myAttendeesDonate: "/:clientKey/:urlKey/:eventNumber/my/attendees/donate",
    myAttendeesDownload: "/:clientKey/:urlKey/:eventNumber/my/attendees/download",
    myPaymentsSummary: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId?/summary",
    myGroupPaymentsSummary: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/summary"),
    myOrderPaymentsSummary: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/summary"),
    myAttendeesPaymentsSummary: "/:clientKey/:urlKey/:eventNumber/my/attendees/summary",
    myPayments: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId?/pay",
    myGroupPayments: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/pay"),
    myOrderPayments: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/pay"),
    myAttendeesPayments: "/:clientKey/:urlKey/:eventNumber/my/attendees/pay",
    myAttendee: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid),
    myAttendeeEdit: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/edit"),
    myAttendeeGift: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/gift"),
    myAttendeeShare: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/share"),
    myAttendeePayments: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/payments"),
    myAttendeeDonate: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/donate"),
    myAttendeeType: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/type"),
    myAttendeeDownload: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/download"),
    myAttendeeGroup: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/group"),
    myAttendeeGroupLeave: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/leave"),
    myAttendeeGroupCreate: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/create"),
    myAttendeeCommunity: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/community"),
    myAttendeeCommunityLeave: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId".concat(Regex.guid, "/leavecommunity"),
    myAttendeeError: "/:clientKey/:urlKey/:eventNumber/my/attendees/:badAttendeeId",
    myOrders: "/:clientKey/:urlKey/:eventNumber/my/orders",
    myOrder: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid),
    myOrderAttendees: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees"),
    myOrderAttendeesPayment: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/payment"),
    myOrderAttendeesShare: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/share"),
    myOrderAttendeesDonate: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/donate"),
    myOrderAttendeesDownload: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/download"),
    myOrderReceipt: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/receipt"),
    myOrderError: "/:clientKey/:urlKey/:eventNumber/my/orders/:badOrderId",
    myGroup: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid),
    myGroupAttendees: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/attendees"),
    myGroupAttendeesPayment: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/attendees/payment"),
    myGroupAttendeesShare: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/attendees/share"),
    myGroupAttendeesDonate: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/attendees/donate"),
    myGroupAttendeesDownload: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/attendees/download"),
    myGroupEdit: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId".concat(Regex.guid, "/edit"),
    myGroupError: "/:clientKey/:urlKey/:eventNumber/my/groups/:badOrderId",
    myDashboard: "/:clientKey/:urlKey/:eventNumber/my/:lookupId?",
    portalAttendeeTicket: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId/ticket",
    portalAttendeePrint: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId/print",
    portalAttendeeCode: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId/code",
    portalAttendeePass: "/:clientKey/:urlKey/:eventNumber/my/attendees/:attendeeId/pass",
    portalGroupTicket: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId/ticket",
    portalGroupPrint: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId/print",
    portalGroupCode: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId/code",
    portalGroupPass: "/:clientKey/:urlKey/:eventNumber/my/groups/:groupId/pass",
    portalOrderTickets: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId".concat(Regex.guid, "/attendees/tickets"),
    portalOrderPrint: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId/print",
    portalOrderCode: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId/code",
    portalOrderPass: "/:clientKey/:urlKey/:eventNumber/my/orders/:orderId/pass",
    portalCal: "/:clientKey/:urlKey/:eventNumber/ical",
    tix: "/tix/:orderId",
};
var FieldsWithOptions = [
    FieldType[FieldType.Checkboxes],
    FieldType[FieldType.Dropdown],
    FieldType[FieldType.Radiobuttons],
    FieldType[FieldType.ItemAmount],
    FieldType[FieldType.ItemList],
];
var PaymentMethods = {
    PAYMENTMETHOD_NOCHARGE: "00000000-0000-0000-0000-000000000000",
    PAYMENTMETHOD_AMERICANEXPRESS: "00000000-0000-0000-0000-000000000001",
    PAYMENTMETHOD_DISCOVER: "00000000-0000-0000-0000-000000000002",
    PAYMENTMETHOD_MASTERCARD: "00000000-0000-0000-0000-000000000003",
    PAYMENTMETHOD_VISA: "00000000-0000-0000-0000-000000000004",
    PAYMENTMETHOD_CASH: "00000000-0000-0000-0000-000000000006",
    PAYMENTMETHOD_ECHECK: "00000000-0000-0000-0000-000000000005",
    PAYMENTMETHOD_CHECKPO: "00000000-0000-0000-0000-000000000007",
    PAYMENTMETHOD_DONATION: "00000000-0000-0000-0000-000000000009",
    PAYMENTMETHOD_SEASON: "00000000-0000-0000-0000-000000000010",
    PAYMENTMETHOD_CONSIGNMENT: "00000000-0000-0000-0000-000000000011",
    PAYMENTMETHOD_SQUARE: "00000000-0000-0000-0000-000000000012",
    PAYMENTMETHOD_PAYPAL: "00000000-0000-0000-0000-000000000013",
    PAYMENTMETHOD_IMPORT: "00000000-0000-0000-0000-000000000014",
    PAYMENTPROFILE_NONE: "No Payment Gateway",
};
var Gateways = {
    GATEWAY_STRIPE: "00000000-0000-0000-0000-000000000001",
    GATEWAY_AUTHORIZENET: "00000000-0000-0000-0000-000000000002",
    GATEWAY_PAYPAL: "00000000-0000-0000-0000-000000000004",
    GATEWAY_TRANSNATIONAL: "00000000-0000-0000-0000-000000000007",
    GATEWAY_PAPERLESSTRANSACTION: "00000000-0000-0000-0000-000000000008",
    GATEWAY_PAYFLOWPRO: "00000000-0000-0000-0000-000000000009",
    GATEWAY_WEPAY: "00000000-0000-0000-0000-000000000011",
    GATEWAY_BOLT: "00000000-0000-0000-0000-000000000014",
    GATEWAY_NETWORKMERCHANTS: "00000000-0000-0000-0000-000000000015",
    GATEWAY_PURPOSEFINANCIAL: "00000000-0000-0000-0000-000000000016",
    GATEWAY_SQUARE: "00000000-0000-0000-0000-000000000017",
    GATEWAY_BLUEFIN: "00000000-0000-0000-0000-000000000019",
    GATEWAY_PAYSAFE: "00000000-0000-0000-0000-000000000020",
    GATEWAY_SQUARE_SANDBOX: "00000000-0000-0000-0000-000000000021",
};
var Cookies = {
    KIOSK: "brushfire_kiosk",
    KIOSK_LAYOUT: "brushfire_kiosk_layout",
    KIOSK_HOMEURL: "brushfire_kiosk_homeurl",
};
var Constants = {
    Cookies: Cookies,
    FieldsWithOptions: FieldsWithOptions,
    Gateways: Gateways,
    PaymentMethods: PaymentMethods,
    RecaptchaSiteKey: "6LcRZf4kAAAAAAmdhqyoVDYEvZyDY_FQ5xLWTtiJ",
    Regex: Regex,
    Routes: Routes,
};
export default Constants;
